;(function() {
  'use strict'

  directive.$inject = ["$document"];
  angular.module('app.survey').directive('glDragAndDrop', directive)

  /* @ngInject */
  function directive($document) {
    return {
      restrict: 'A',
      scope: {
        onOver: '&',
        onDrop: '&',
      },
      link: function(scope, element) {
        var DRAG_START_THRESHOLD = 10 // pixels threshold for starting the drag
        var initialX,
          initialY,
          clonedElement,
          isDragging = false,
          targetElement = null

        element.on('pointerdown', onPointerDown)
        scope.$on('$destroy', function() {
          element.off('pointerdown', onPointerDown)
        })

        function onPointerDown(event) {
          event.preventDefault() // to prevent mouse selecting text on drag

          var rect = element[0].getBoundingClientRect()
          initialX = event.clientX - rect.left
          initialY = event.clientY - rect.top

          $document.on('pointermove', onPointerMove)
          $document.on('pointerup', onPointerUp)
        }

        function onPointerMove(event) {
          var isDragStarted =
            Math.abs(event.clientX - initialX) > DRAG_START_THRESHOLD ||
            Math.abs(event.clientY - initialY) > DRAG_START_THRESHOLD

          if (!isDragging && !isDragStarted) return

          if (!isDragging) {
            isDragging = true
            clonedElement = element.clone()
            clonedElement.addClass('-dragging')
            angular.element($document[0].body).append(clonedElement)
            element.css('visibility', 'hidden')
          }

          // move the cloned element with the pointer
          clonedElement.css({
            left: event.pageX - initialX + 'px',
            top: event.pageY - initialY + 'px',
          })

          var elementBelow = $document[0].elementFromPoint(
            event.clientX,
            event.clientY
          )
          var droppableElement = elementBelow
            ? elementBelow.closest('.-droppable')
            : null

          if (targetElement === droppableElement) return

          targetElement = droppableElement
          scope.$applyAsync(function(scope) {
            scope.onOver({
              $targetId: targetElement ? targetElement.id : null,
            })
          })
        }

        function onPointerUp() {
          $document.off('pointermove', onPointerMove)
          $document.off('pointerup', onPointerUp)

          scope.$applyAsync(function(scope) {
            scope.onOver({ $targetId: null })
          })

          if (!isDragging) return

          isDragging = false // reset the flag
          clonedElement.remove()
          element.css('visibility', 'visible')

          if (targetElement) {
            scope.$applyAsync(function(scope) {
              scope.onDrop({ $targetId: targetElement.id })
              targetElement = null
            })
          }
        }
      },
    }
  }
})()
